import IMask from '../../vendor/imask/dist/imask';

export default class DateMask {
    constructor($field) {
        this.$field = $field;
        this.alignCursor = false;

        this.prepare = this.prepare.bind(this);
        this.updateCursor = this.updateCursor.bind(this);

        this.mask = new IMask(this.$field, {
            mask: '00/00/0000',
            prepare: this.prepare,
        });

        this.$field.addEventListener('input', this.updateCursor);
    }

    prepare(value, masked) {
        if (value !== '/') {
            return value;
        }

        const currentValue = masked.value;
        const parts = currentValue.split('/');
        const currentPart = parts.at(-1);

        if (currentPart?.length === 1) {
            parts[parts.length - 1] = `0${currentPart}`;
            masked.value = parts.join('/');
            this.alignCursor = true;
        }

        return '';
    }

    updateCursor() {
        if (!this.alignCursor) {
            return;
        }

        this.alignCursor = false;
        this.mask.updateCursor(this.$field.value.length);
    }
}
